import React, { useEffect, useState } from 'react';
import st from './style.module.scss';
import { useTranslation } from 'react-i18next';
import { getCardData } from './constants';
import { getLandingInfo } from '../../../../api/public';

const CardStats = () => {
  const [Info, setInfo] = useState([]);
  useEffect(() => {
    getLandingInfo()
      .then(res => {
        const data = res?.data?.data;
        setInfo(data?.info);
      })
      .catch(err => {
        console.log(err);
      });
  }, [setInfo]);

  const { t } = useTranslation();
  const CARD_DATA = getCardData(t, Info);
  return (
    <div className="container">
      <div className="row">
        {CARD_DATA.map(item => (
          <div key={item.id} className="col-6 col-md-4 col-lg-3 p-1">
            <CardItem icon={item.icon} type={item.type} count={item.count} />
          </div>
        ))}
      </div>
    </div>
  );
};

const CardItem = ({ icon, type, count }) => {
  return (
    <div className={st.cardStatsWrap}>
      <div className={st.cardIconWrap}>{icon}</div>
      <div className={st.cardStats}>
        <p className={st.cardStatsCount}>{type}</p>
        <p className={st.cardStatsTypeJob}>{count}</p>
      </div>
    </div>
  );
};
export default CardStats;
